export const DeviceStatus = {
    NoIssues: 'NoIssues',
    Warning: 'Warning',
    Danger: 'Danger',
};
